import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const PersonDopper = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="225" viewBox="0 0 396 225" width="396" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        d="M34.99 77.14S15.2 64.81 4.3 72.84c-15.36 11.32 15.34 33.55 15.34 33.55S-7.86 122.31 4.3 132.2c16.92 13.76 50.18-12.05 50.76-11.18.58.86 6.99 14.91 16.92 16.35 12.05 1.74 19.22-5.45 19.22-5.45s25.23 21.22 43.87 4.3c9.04-8.21-5.16-29.54-5.16-29.54s56.02-13.61 43.87-27.53c-13.76-15.77-77.43-.29-77.14-1.15.28-.86 14.61-21.21-5.74-26.96-24.38-6.88-55.92 26.1-55.92 26.1z"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="M199.48 217.14c57.73 0 104.53-3.85 104.53-8.59s-46.8-8.59-104.53-8.59-104.53 3.85-104.53 8.59 46.8 8.59 104.53 8.59Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        d="M168.23 192.35c-3.49 9.16-13.1 13.23-17.61 14.68h-38.19c-12.68 0-22.26-22.07-19.83-34.51 2.34-11.94 8.44-28.95 18.33-45.78a125 125 0 0 0 34.72 10.7q-1 6.2-1.64 12.61a39 39 0 0 1 14.21 7.94c8.25 7.15 13.61 24.91 10.01 34.36Z"
        fill={shades.secondary.light}
      />
      <path
        d="M278.73 207.03h-36.71c-3.98-3.03-19.46-16.21-15.38-34.98 2.54-11.7 12.53-19.27 22.62-24.04q-.32-4.5-.83-8.93c13.29-2 25.65-6.04 37.24-11.86 7.42 13.25 12.68 26.37 16.37 36.52 6.64 18.28-3.85 43.29-23.3 43.29z"
        fill={shades.secondary.light}
      />
      <path
        d="M277.83 114.53a93 93 0 0 1-31.39 11.32q-.85-4.54-1.96-8.97a93 93 0 0 0 27.54-10.32q3.07 3.91 5.82 7.97z"
        fill={shades.white}
      />
      <path
        d="M285.67 127.23a123 123 0 0 1-37.24 11.86q-.77-6.74-2-13.24a93 93 0 0 0 31.39-11.32 172 172 0 0 1 7.84 12.69z"
        fill={shades.secondary.medium}
      />
      <path
        d="M150.73 115.13a154 154 0 0 0-2.45 9.06A94 94 0 0 1 119.24 114a150 150 0 0 1 6.08-7.87 94 94 0 0 0 25.41 9.01z"
        fill={shades.white}
      />
      <path
        d="M148.28 124.19a173 173 0 0 0-2.63 13.25 124 124 0 0 1-34.72-10.7c2.52-4.29 5.29-8.57 8.31-12.75a94 94 0 0 0 29.04 10.19z"
        fill={shades.secondary.medium}
      />
      <path
        d="M226.65 172.06c-4.08 18.77 11.4 31.94 15.38 34.98h-91.4c4.51-1.45 14.12-5.52 17.61-14.68 3.6-9.45-1.76-27.21-10.01-34.36a39 39 0 0 0-14.21-7.94q.64-6.41 1.64-12.61a173 173 0 0 1 5.08-22.31 94 94 0 0 1-25.41-9.01c17.48-21.11 41.77-37.97 72.9-37.97 33.56 0 57.19 17.28 73.79 38.41a92 92 0 0 1-27.54 10.32q1.12 4.42 1.96 8.97 1.22 6.5 2 13.24.51 4.41.83 8.93c-10.09 4.77-20.08 12.34-22.62 24.04z"
        fill={shades.secondary.light}
      />
      <path d="M246.43 125.85q-3.32.55-6.74.87z" fill={shades.secondary.light} />
      <path d="M248.43 139.09q-3.59.54-7.27.88z" fill={shades.secondary.light} />
      <path d="M150.62 207.03c-1.48.47-2.4.67-2.4.67z" fill={shades.secondary.light} />
      <path d="m242.94 207.7-.92-.67z" fill={shades.secondary.light} />
      <path
        className={strokeStyle}
        d="M112.43 207.03c-12.68 0-22.26-22.07-19.83-34.51 6.45-32.91 41.51-104.37 105.62-104.37s91.99 63.05 103.81 95.59c6.64 18.28-3.85 43.29-23.3 43.29z"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M117.36 151.04s22.02-9.39 40.86 6.96c8.24 7.15 13.61 24.92 10.01 34.36-4.64 12.14-20.01 15.35-20.01 15.35"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M273.31 140.65s-41.11 5.84-46.66 31.41c-4.67 21.49 16.29 35.64 16.29 35.64"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M150.22 160.08c-6.68-4.04-14.14-1.24-17.29 9.31-3.16 10.55 2.44 33.31 12.32 30.94 5.29-1.27 17.27-9.06 17.52-19.36.22-8.93-5.87-16.85-12.54-20.89z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M248.61 158.5c-5.7-.25-12.52 4.1-14.69 15.01s3.21 24.5 12.02 25.35 14.51-10.61 16.18-20.62-7.81-19.49-13.51-19.74Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M241.7 76.71c-9.13 11.99-47.79 13.3-73.37 7.59-11.63-2.6-17.86-5.83-20.09-10.11-2.15-4.12 3.31-11.41 12.2-13.76 11.11-2.94 43.8-5.46 63.85-2.23 17.27 2.78 23.55 10.44 17.41 18.51Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M197.41 82.1c13.56 0 24.55-3.68 24.55-8.22s-10.99-8.21-24.55-8.21-24.55 3.68-24.55 8.21 10.99 8.22 24.55 8.22Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        d="M182.98 83.63c-2.06-.22-2.91 5.56-3.74 9.86-.82 4.29-1.43 11.72 1.28 11.71 3.01-.01 1.58-6.94 2.37-11.08.9-4.77 2.07-10.28.09-10.49Z"
        fill={shades.primary.medium}
      />
      <path
        d="M214.6 83.63c-2.97 0-1 8.56-1.03 14.87-.04 11.02-3.5 15.15.59 15.73 2.74.38 3.88-10.37 3.99-16.45.13-7.01-.69-14.14-3.55-14.14z"
        fill={shades.primary.medium}
      />
      <path className={strokeStyle} d="M144.01 150.05c1.62-16.04 4.79-31.18 10.21-45.01" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M240.89 104.86c4.67 13.38 7.26 27.88 8.38 43.16" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M117.36 151.04s22.02-9.39 40.86 6.96c8.24 7.15 13.61 24.92 10.01 34.36-4.64 12.14-20.01 15.35-20.01 15.35"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M273.31 140.65s-41.11 5.84-46.66 31.41c-4.67 21.49 16.29 35.64 16.29 35.64"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M150.22 160.08c-6.68-4.04-14.14-1.24-17.29 9.31-3.16 10.55 2.44 33.31 12.32 30.94 5.29-1.27 17.27-9.06 17.52-19.36.22-8.93-5.87-16.85-12.54-20.89z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M248.61 158.5c-5.7-.25-12.52 4.1-14.69 15.01s3.21 24.5 12.02 25.35 14.51-10.61 16.18-20.62-7.81-19.49-13.51-19.74Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M197.41 223.37c32.48 0 58.8-2.86 58.8-6.39s-26.33-6.39-58.8-6.39-58.8 2.86-58.8 6.39 26.33 6.39 58.8 6.39Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        d="M246.83 206.88H146.31c-.58 0-1.05.47-1.05 1.05v4.74c0 .58.47 1.05 1.05 1.05h100.52c.58 0 1.05-.47 1.05-1.05v-4.74c0-.58-.47-1.05-1.05-1.05Z"
        fill={shades.white}
      />
      <path
        d="M246.28 208.89h-99.37a4.14 4.14 0 0 1-4.14-4.14l-2.94-63.1a4.14 4.14 0 0 1 4.14-4.14h105.26a4.14 4.14 0 0 1 4.14 4.14l-2.94 63.1a4.14 4.14 0 0 1-4.14 4.14z"
        fill={shades.white}
      />
      <path d="M204.12 168.18v10.03h-5.01v-5.02h-5.01v5.02h-5.01v-10.03h15.04z" fill={shades.black} />
      <path
        d="M166.89 199.75a10.4 10.4 0 0 1-6.84-5 5.8 5.8 0 0 1-.12-5.36 4.8 4.8 0 0 1 5.64-2.57l.13-.1a5.5 5.5 0 0 1 4.15-1.09 5.3 5.3 0 0 1 3.77 2.49c1.49 2.46.28 5.56-.58 7.18s-2.67 4.35-5.26 4.49q-.4.02-.88-.04z"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="M166.66 190.59s-2.86-2.38-4.12.12c-1.56 3.11 3.49 6.26 5.08 6.17 1.6-.08 4.72-5.23 3.49-7.25-1.15-1.89-4.25-1.33-4.46.96z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        d="m222.94 166.07-3.57.5c-2.78.39-4.36-3.09-2.24-4.93l3.77-3.28a2.8 2.8 0 0 0 .82-3.04l-1.3-3.83a2.82 2.82 0 0 1 4.18-3.3l2.89 1.81c1.05.66 2.41.55 3.35-.26l3.63-3.15c2.19-1.9 5.47.33 4.52 3.06l-1.42 4.08a2.8 2.8 0 0 0 1.17 3.32l2.34 1.46a2.82 2.82 0 0 1-1.11 5.19l-4.46.61a2.8 2.8 0 0 0-2.28 1.87l-1.25 3.58a2.82 2.82 0 0 1-5.34-.02l-.61-1.79a2.8 2.8 0 0 0-3.06-1.89h-.01z"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="m237.77 160.51-6.59.91-1.88 5.4-1.67-4.9-6.54.92 5.3-4.61-2.1-6.18 5.36 3.36 5.22-4.53-2.24 6.41 5.15 3.22z"
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m221.09 162.84 13.76-11.95-5.55 15.95-5.02-14.77 13.5 8.46z" strokeWidth={strokeWidth} />
      <path
        d="m175.99 192.63-.4-2.84.8-.11.06.39a.9.9 0 0 1 .74-.55q.66-.08.94.39c.11-.29.42-.58.87-.64.62-.09 1.08.26 1.16.81l.27 1.93-.8.11-.24-1.7c-.04-.32-.25-.49-.54-.45-.35.05-.5.37-.44.84l.21 1.45-.8.11-.24-1.7q-.09-.5-.54-.45c-.35.05-.51.38-.45.84l.2 1.45zm6.3-3.79.81-.11-.72 3.17c-.09.41-.32.97-1.07 1.07a1 1 0 0 1-.44-.01l-.1-.68q.1.04.34.02c.25-.04.49-.13.61-.45l-1.52-2.71.8-.11.91 1.81.36-1.99zm2.27 3.67-.22.02-.1-.68.13-.01q.4-.07.34-.57l-.38-2.71.8-.11.4 2.79c.1.68-.29 1.17-.97 1.27Zm-.3-4.31-.11-.78.85-.12.11.78zm3.16 2.86a1.44 1.44 0 0 1-1.68-1.26 1.43 1.43 0 0 1 1.26-1.67c.85-.12 1.56.41 1.68 1.25s-.42 1.55-1.27 1.68zm-.09-.69c.39-.06.62-.42.55-.88s-.38-.74-.77-.68c-.4.06-.62.42-.55.87.07.46.37.75.77.69Zm3.54.2c-.34.05-.65-.05-.81-.23l.04.29-.8.11-.56-3.99.8-.11.2 1.43a1 1 0 0 1 .73-.43c.82-.11 1.43.38 1.55 1.27s-.32 1.54-1.15 1.66Zm-.23-.67c.4-.06.63-.41.56-.88-.07-.46-.38-.74-.78-.68s-.63.41-.57.87.38.74.79.69Z"
        fill={shades.black}
      />
      <path d="m156.84 196.07-.56-3.94.85-.12.56 3.94z" fill={shades.black} />
      <path
        className={strokeStyle}
        d="M227.65 40.87q-.01 4.24-.92 7.95a27.5 27.5 0 0 1-5.93 11.61c-5.51 6.31-13.82 9.81-23.14 9.81s-17.63-3.5-23.12-9.81a27.4 27.4 0 0 1-5.98-11.84 33 33 0 0 1-.87-7.72c0-18.32 13.42-33.17 29.97-33.17s29.99 14.86 29.99 33.17Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M191.86 49.84v9.14c0 .79-.65 1.44-1.45 1.44h-15.85a27 27 0 0 1-5.98-11.84q.3-.18.69-.18h21.15c.8 0 1.45.65 1.45 1.44z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M226.73 48.82a27.5 27.5 0 0 1-5.93 11.61h-15.76c-.8 0-1.45-.65-1.45-1.44v-9.14c0-.79.65-1.44 1.45-1.44h20.69q.61 0 1.01.42z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M196.25 46.6v10.51c0 .91-.74 1.66-1.66 1.66h-22.07c-.78 0-1.46-.55-1.62-1.31l-1.01-4.69-.81-3.75-.45-2.08a1.65 1.65 0 0 1 1.62-2.01h24.34c.92 0 1.66.74 1.66 1.66z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M196.25 50.61h2.98" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m226.32 46.92-.82 4.19-.38 1.94-.87 4.38a1.66 1.66 0 0 1-1.63 1.34H200.9c-.91 0-1.66-.75-1.66-1.66V46.6c0-.92.74-1.66 1.66-1.66h23.8c1.05 0 1.83.96 1.63 1.98z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M230.81 38.96c-.86 5.34-5.64 9.58-11.56 8.09-7.64-1.92-15.3.27-16.36.74 6.23-7.02.69-22.9.69-22.9.57-6.58-.72-15.3-9.27-17.36 2.77-.88 11.8-4.26 22.39 1.58s15.3 22.41 14.1 29.83z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M208.32 45.18c-6.77 6.72-20.94 8.16-29.32 6.44-9.46-1.94-16.32-7-19.19-10.11-4.1-4.43-4.71-8.95-4.85-12.43a1.73 1.73 0 0 1 2.32-1.69c1.73.63 4.16 1.18 6.2.42 1.13-.42 2.23-1.75 3.2-3.39a46 46 0 0 0 3.68-8.62l.01-.03c6.36-9.41 16.36-10.44 25.8-9.29q.95.12 1.87.35h.01c4.74 1.14 12.53 7.77 14.64 17.24 1.7 7.64-1.39 18.16-4.36 21.11z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m188.41 1.55-.4.45-.26.3c-3.36 3.81-6.92 8.45-8.82 12.27v.01q-.5.8-.93 1.57a115 115 0 0 1-9.45-2.24 32.7 32.7 0 0 1 19.86-12.36Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M178.92 14.59q-.42.84-.72 1.61l-.21-.04z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M197.36 17.78a87 87 0 0 1-19.16-1.59q.3-.78.72-1.61v-.01a106 106 0 0 1 8.82-12.27L188 2l.4-.45q3.15-.65 6.8-.78l.74-.02c.54 4.91.93 11.93 1.42 17.03Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M213.21 15.39a66 66 0 0 1-15.84 2.39c-.48-5.1-.88-12.12-1.42-17.03h.03q3.63-.04 6.81.52.33.05.64.12c3.17 3.57 7.26 9.64 9.78 14.01z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m222.02 12.14-.78.35a59 59 0 0 1-8.03 2.9c-2.52-4.37-6.6-10.44-9.78-14.01a33 33 0 0 1 18.59 10.76Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M178.92 14.59q-.42.84-.72 1.61l-.21-.04z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M226.85 29.51c-20.35 9.17-40.77 9.06-61.28-.15a6.7 6.7 0 0 1-3.3-9.05 41 41 0 0 1 3.31-5.54 2.4 2.4 0 0 1 2.62-.94l.35.1q4.79 1.35 9.45 2.24l.21.04a87 87 0 0 0 19.16 1.59q8.27-.26 15.84-2.39a58 58 0 0 0 8.03-2.9l.78-.35h.03c1-.47 2.19-.2 2.9.65a46 46 0 0 1 5.09 7.53 6.66 6.66 0 0 1-3.19 9.19z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M53.89 212.31c11.91 0 21.56-1.53 21.56-3.42s-9.65-3.42-21.56-3.42-21.56 1.53-21.56 3.42 9.65 3.42 21.56 3.42Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M55.56 172.9c-6.69-.58-8.37 8.6-12.92 9.97-6.61 2.01-11.73 20.3 3.71 24.85s28.66-4.9 23.76-19.43c-3.69-10.93-6.53-14.7-14.55-15.4z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M47.1 166.96c4.55 2.04 6.93 4.26 8.32 9.8" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M55.41 179.56s7.22 2.36 9.95-5.95c1.49-4.55 3.41-8.23 3.41-8.23s-14.85-2.1-13.36 14.18Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path d="M36.22 33.7v10.54" stroke="white" strokeWidth={strokeWidth} />
      <path d="M41.93 38.97H30.5" stroke="white" strokeWidth={strokeWidth} />
      <path d="M384.04 160.84v10.1" stroke="white" strokeWidth={strokeWidth} />
      <path d="M389.46 165.89h-10.84" stroke="white" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M285.12 9.55v1.94" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M281.44 6.44h-1.74" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M284.96 3.3V1.37" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M288.64 6.41h1.74" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M309.72 53.37v5.47a3.2 3.2 0 0 1-3.22 3.21h-38.77c-.66 0-1.28-.21-1.79-.54l-.17-.14h-.02a3.2 3.2 0 0 1-1.22-2.52v-5.47a3.2 3.2 0 0 1 3.21-3.22h38.77c.9 0 1.72.37 2.29.97l.04.03c.46.5.78 1.15.85 1.85z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        d="M375.8 45.09v5.47a3.2 3.2 0 0 1-3.22 3.21h-38.77c-.66 0-1.28-.21-1.8-.54l-.17-.15h-.01a3.2 3.2 0 0 1-1.22-2.52v-5.47a3.2 3.2 0 0 1 3.21-3.22h38.77c.9 0 1.72.37 2.29.97l.04.03c.46.5.78 1.15.85 1.85z"
        fill={shades.white}
      />
      <path
        d="M395.35 62.04v5.47a3.2 3.2 0 0 1-3.22 3.21h-38.77c-.66 0-1.28-.21-1.79-.54l-.17-.14h-.02a3.2 3.2 0 0 1-1.22-2.52v-5.47a3.2 3.2 0 0 1 3.21-3.22h38.77c.89 0 1.72.37 2.29.97l.04.03c.45.5.78 1.15.85 1.85z"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="M313.13 56.21v5.47a3.2 3.2 0 0 1-3.21 3.22h-38.77c-.88 0-1.69-.35-2.26-.94l-.03-.03-2.93-2.43q.78.53 1.79.54h38.77a3.2 3.2 0 0 0 3.22-3.21v-5.47q0-.2-.03-.37a3.3 3.3 0 0 0-.85-1.85l2.88 2.4.17.13a3.2 3.2 0 0 1 1.23 2.53z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M328.65 71.62v5.47a3.2 3.2 0 0 1-3.22 3.21h-38.77q-.99-.02-1.75-.51l-.04-.03a3.2 3.2 0 0 1-1.41-2.66v-5.47a3.2 3.2 0 0 1 3.21-3.22h38.77c.89 0 1.69.35 2.28.94l.04.04a3.3 3.3 0 0 1 .89 2.24z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M332.06 74.46v5.47a3.2 3.2 0 0 1-3.21 3.22h-38.77c-.96 0-1.82-.43-2.4-1.1l-.03-.03-2.75-2.23q.76.5 1.75.51h38.77a3.2 3.2 0 0 0 3.22-3.21v-5.47l-.01-.37a3.3 3.3 0 0 0-.88-1.87l2.9 2.41.1.07a3.2 3.2 0 0 1 1.31 2.59z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M316.84 29.79v5.47a3.2 3.2 0 0 1-3.22 3.21h-20.74q-.99-.02-1.75-.51l-.04-.03a3.2 3.2 0 0 1-1.41-2.66V29.8a3.2 3.2 0 0 1 3.21-3.22h20.74c.89 0 1.69.35 2.28.94l.04.04a3.3 3.3 0 0 1 .89 2.24z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M320.25 32.63v5.47a3.2 3.2 0 0 1-3.21 3.22H296.3c-.96 0-1.82-.43-2.4-1.1l-.03-.03-2.75-2.24q.76.5 1.75.51h20.73a3.2 3.2 0 0 0 3.22-3.21v-5.47l-.02-.37a3.3 3.3 0 0 0-.88-1.87l2.9 2.41.1.07a3.2 3.2 0 0 1 1.31 2.59z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M104.86 50.26v17.82a5.33 5.33 0 0 1-5.32 5.32H58.33q-.59 0-1.14-.14a5 5 0 0 1-2.9-1.76 5.3 5.3 0 0 1-1.28-3.43V50.25a5.3 5.3 0 0 1 5.32-5.32h41.21c1.8 0 3.39.89 4.33 2.25l.35.54.04.1q.6 1.1.6 2.44Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path d="M66.86 61.18a2.01 2.01 0 1 0 0-4.02 2.01 2.01 0 0 0 0 4.02Z" fill={shades.primary.dark} />
      <path d="M78.94 61.18a2.01 2.01 0 1 0 0-4.02 2.01 2.01 0 0 0 0 4.02Z" fill={shades.primary.dark} />
      <path d="M91.01 61.18a2.01 2.01 0 1 0 0-4.02 2.01 2.01 0 0 0 0 4.02Z" fill={shades.primary.dark} />
      <path
        className={strokeStyle}
        d="M109.04 57.05v17.82c0 2.94-2.4 5.32-5.32 5.32H62.51a5.3 5.3 0 0 1-4.76-2.96l-.02-.02-3.44-5.71a5 5 0 0 0 2.9 1.76q.56.14 1.14.14h41.21c2.94 0 5.32-2.4 5.32-5.32V50.26a5 5 0 0 0-.6-2.44l3.79 6.17.14.21c.54.81.85 1.8.85 2.84z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M350.12 209.98c11.91 0 21.56-1.53 21.56-3.42s-9.65-3.42-21.56-3.42-21.56 1.53-21.56 3.42 9.65 3.42 21.56 3.42Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M364.99 136.22v14.21c-10.5 1.9-21.18 1.74-32.01-.07v-14.14c0-5.4 4.38-9.77 9.77-9.77h12.47c5.4 0 9.77 4.37 9.77 9.77Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M364.99 150.43v46.32c0 5.4-4.37 9.77-9.77 9.77h-12.47a9.77 9.77 0 0 1-9.77-9.77v-46.39c10.83 1.81 21.5 1.97 32.01.07Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path d="M355.14 137.44v8.19h-4.1v-4.1h-4.1v4.1h-4.09v-8.19z" fill={shades.white} />
      <path
        d="M355.91 192.25c-2.39 0-4.24-1.72-5.41-3.02-3.51-3.86-9.91-14.24-6.05-19.98 1.72-2.55 3.79-2.94 4.87-2.94q1.04 0 1.96.39c1.11-2.5 2.94-4.66 5.92-4.74 1.57 0 2.9.62 3.86 1.75 3 3.49 2.15 12.51 1.37 17.58l-.02.16c-.77 5.06-1.65 10.81-6.51 10.81z"
        fill={shades.white}
      />
      <path
        d="M352.93 174.01c-1.77-4.71-3.98-5.48-5.72-2.89-2.38 3.54 2.29 12.07 5.75 15.87 4.52 4.97 5.33-.6 6.18-6.21.81-5.29 1.55-15.58-1.86-15.49-3.62.1-4.36 8.71-4.36 8.71z"
        fill={shades.primary.medium}
      />
      <path className={strokeStyle} d="M355.75 119.99h-13.52v6.47a24.5 24.5 0 0 0 13.52 0z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M364.96 109.07h-31.8l4.17 7.04c1.42 2.4 2.54 3.88 5.34 3.88h12.79c2.8 0 3.91-1.48 5.34-3.88z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M364.82 109.07c0 .74-5.17 1.33-15.17 1.33s-16.64-.6-16.64-1.33 6.64-1.33 16.64-1.33 15.17.6 15.17 1.33Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
